function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4_7)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M319.98 448.1C350.908 448.1 375.98 423.028 375.98 392.1C375.98 361.172 350.908 336.1 319.98 336.1C289.052 336.1 263.98 361.172 263.98 392.1C263.98 423.028 289.052 448.1 319.98 448.1Z",
  fill: "#3D55DC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.83 153.7C114.53 87.9 212.53 48 319.93 48C427.33 48 525.33 87.9 600.03 153.7C609.93 162.5 625.13 161.5 633.93 151.5C642.73 141.5 641.73 126.4 631.73 117.6C548.63 44.4 439.43 0 319.93 0C200.43 0 91.23 44.4 8.12997 117.6C-1.77003 126.4 -2.77003 141.5 5.92997 151.5C14.63 161.5 29.83 162.4 39.83 153.7Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M319.93 224C384.53 224 443.43 248.7 487.53 289.2C497.33 298.2 512.43 297.5 521.43 287.7C530.43 277.9 529.73 262.8 519.93 253.8C467.33 205.5 397.03 176 319.93 176C242.83 176 172.53 205.5 119.83 253.9C110.03 262.9 109.43 278 118.33 287.8C127.23 297.6 142.43 298.2 152.23 289.3C196.43 248.7 255.33 224 319.93 224Z",
  fill: "black"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4_7"
}, /*#__PURE__*/React.createElement("rect", {
  width: 639.93,
  height: 448.1,
  fill: "white"
})));

function SvgWifiPermit3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 449,
    viewBox: "0 0 640 449",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiPermit3);
export default __webpack_public_path__ + "static/media/wifi-permit3.c7f11057.svg";
export { ForwardRef as ReactComponent };